import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelIe.mjs'

export default function PropertiesPaneIe(props) {
    return (
        <ComponentPropertiesPane
            controllers={
                <>
                    <Text prop="ieTitle" />
                    <Text prop="ieUserCode" />
                    <Text prop="dataType" />
                    <Text prop="dataLen" />
                    <Text prop="dataUnit" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        //'Depend',
                        'Effect',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
